import { render, staticRenderFns } from "./AttendanceAttend.vue?vue&type=template&id=06be59bc&scoped=true&"
import script from "./AttendanceAttend.vue?vue&type=script&lang=js&"
export * from "./AttendanceAttend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be59bc",
  null
  
)

export default component.exports